import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import {
	type ContentState,
	type ContentTabs,
	moduleName,
} from "./content.types";

const initialState: ContentState = {
	activeTab: "ACTIONS",
};

const slice = createSlice({
	name: moduleName,
	initialState,
	reducers: {
		setActiveTab: (state, action: PayloadAction<ContentTabs>) => {
			state.activeTab = action.payload;
		},
	},
});

export default slice;
